import React from "react";
import { ItemMinicart } from "components/ProductItem";
import { formatPrice } from "utils";
import { InstantCheckout } from "components/InstantCheckout";

const List = ({ cartProducts, cartPrice, handleEmptyCartClick, cartId }) => (
  <div>
    <ul className="cartPage__cartList">
      {cartProducts.map(product => (
        <ItemMinicart key={product.sku} product={product} />
      ))}
    </ul>
    <div className="cartPage__totals">
      <div>
        <strong>CART TOTAL: </strong>
        {formatPrice(cartPrice)}
      </div>
    </div>
    <div className="cartPage__actions">
      <button onClick={handleEmptyCartClick} className="button">
        Empty Cart
      </button>
      <InstantCheckout cartId={cartId} />
    </div>
  </div>
);
export default List;



// WEBPACK FOOTER //
// ./src/modules/Cart/components/List.jsx